export const socialsData = {
    github: 'https://github.com/elsahtz2',
    linkedIn: 'https://www.linkedin.com/in/elsa-heitz/',
}